module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.46b1ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/fullscreen-image_hero.png
// module id = nBmW
// module chunks = 0